export const TEST_ID = 'droneCardDetails';
